<div class="support-prelogin-container">
	<div class="hero-section">
		<div class="container">
			<a class="back-btn btn btn-light" routerLink="/login" aria-label="Back to login"><i
					class="fas fa-arrow-left"></i>{{ t('back')}}</a>
			<div class="logo-wrap">
				<img src="./facewithlogo.svg" alt="DR.Piyu Logo" class="logo">
			</div>
			<div class="top-right-lang"><app-language-selector [isDarkBackground]="true"></app-language-selector></div>
			<h1 class="hero-title">{{ t('support') }}</h1>
			<p class="hero-subtitle">{{ t('pleaseLogin') }}</p>
		</div>
	</div>

	<div class="container">
		<div class="info-grid">
			<div class="info-card contact-card">
				<div class="card-header">
					<div class="header-icon">
						<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
							stroke-width="2">
							<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
							<circle cx="12" cy="10" r="3" />
						</svg>
					</div>
					<h3>{{ t('companyName') }}</h3>
				</div>

				<div class="contact-info-compact">
					<div class="contact-row">
						<div class="contact-item-compact">
							<div class="contact-icon">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
									stroke-width="2">
									<path
										d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" />
									<polyline points="22,6 12,13 2,6" />
								</svg>
							</div>
							<div class="contact-details">
								<span class="contact-label">{{ t('contactEmail_title') }}</span>
								<a [href]="'mailto:' + t('contactEmail_addresses')" class="contact-value" [innerHTML]="t('contactEmail_addresses')"></a>
							</div>
						</div>
					</div>

					<div class="address-section">
						<div class="contact-item-compact address-item">
							<div class="contact-icon">
								<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor"
									stroke-width="2">
									<path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
									<circle cx="12" cy="10" r="3" />
								</svg>
							</div>
							<div class="contact-details">
								<span class="contact-label">{{ t('contactLocation_title') }}</span>
								<div class="branch-addresses">
									<div class="branch-address">
										<strong>{{ t('contactLocation_branch1_title') }}:</strong>
										<div class="branch-info">
											<div class="branch-address-text">
												<span class="info-label">{{ t('contactLocation_title') }}:</span>
												<span class="info-content" [innerHTML]="t('contactLocation_branch1_address')"></span>
											</div>
											<div class="branch-phone-text">
												<span class="info-label">{{ t('contactPhone_title') }}:</span>
												<span class="info-content" [innerHTML]="t('contactPhone_branch1_numbers')"></span>
											</div>
										</div>
									</div>
									<div class="branch-address">
										<strong>{{ t('contactLocation_branch2_title') }}:</strong>
										<div class="branch-info">
											<div class="branch-address-text">
												<span class="info-label">{{ t('contactLocation_title') }}:</span>
												<span class="info-content" [innerHTML]="t('contactLocation_branch2_address')"></span>
											</div>
											<div class="branch-phone-text">
												<span class="info-label">{{ t('contactPhone_title') }}:</span>
												<span class="info-content" [innerHTML]="t('contactPhone_branch2_numbers')"></span>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>

				<div class="social-links" aria-label="Social media links">
					<a href="https://www.facebook.com/priyanka.dhanwade.5" target="_blank" rel="noopener"
						aria-label="Facebook">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="#1877F2">
							<path
								d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
						</svg>
					</a>
					<a href="https://www.instagram.com/dr._piyu_24/" target="_blank" rel="noopener"
						aria-label="Instagram">
						<svg width="18" height="18" viewBox="0 0 24 24">
							<defs>
								<linearGradient id="instagram-gradient-support" x1="0%" y1="0%" x2="100%" y2="100%">
									<stop offset="0%" style="stop-color:#833AB4;stop-opacity:1" />
									<stop offset="50%" style="stop-color:#E1306C;stop-opacity:1" />
									<stop offset="100%" style="stop-color:#F77737;stop-opacity:1" />
								</linearGradient>
							</defs>
							<path fill="url(#instagram-gradient-support)"
								d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
						</svg>
					</a>
					<a href="https://www.youtube.com/@dr.piyuheightclinic" target="_blank" rel="noopener"
						aria-label="YouTube">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="#FF0000">
							<path
								d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z" />
						</svg>
					</a>
					<a [href]="whatsappUrl" target="_blank" rel="noopener" aria-label="WhatsApp">
						<svg width="18" height="18" viewBox="0 0 24 24" fill="#25D366">
							<path
								d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.890-5.335 11.893-11.893A11.821 11.821 0 0020.886 3.488" />
						</svg>
					</a>
				</div>
			</div>

			<div class="info-card policies-card">
				<div class="card-content">
					<div class="card-header">
						<div class="header-icon">
							<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
								<path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
								<polyline points="14,2 14,8 20,8"/>
								<line x1="16" y1="13" x2="8" y2="13"/>
								<line x1="16" y1="17" x2="8" y2="17"/>
								<polyline points="10,9 9,9 8,9"/>
							</svg>
						</div>
						<h3>{{ t('importantInformation') }}</h3>
					</div>
					
					<div class="card-body">
						<p>{{ t('openPoliciesLearnMore') }} {{ t('needQuickSupport') }} <a class="call-link" href="tel:+919890446677"><i class="fas fa-phone"></i> {{ t('callUs') }}</a></p>
						
						<!-- Clinic image -->
						<div class="clinic-image">
							<img src="https://placehold.co/400x200/0b3976/ffffff?text=Dr.+Piyu's+Height+Clinic" 
								 alt="Dr. Piyus Height Clinic" 
								 class="clinic-img">
						</div>
					</div>
					
					<!-- Policy buttons moved to bottom -->
					<div class="policy-buttons">
						<app-policy-modal #policyModal [showButtons]="true"></app-policy-modal>
					</div>
				</div>
			</div>
		</div>

		<div class="map-wrapper">
			<h2 class="section-title">{{ t('contactMap_title') }}</h2>
			<div class="map-container">
				<iframe
					src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3822.6560028430963!2d74.27191457514826!3d16.64402488412185!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc0ff006b4e3187%3A0x591cfbc7a4c00804!2sDr%20piyu%20height%20clinic!5e0!3m2!1sen!2sin!4v1760860566672!5m2!1sen!2sin"
					width="100%" height="450" style="border:0;" allowfullscreen loading="lazy"
					referrerpolicy="no-referrer-when-downgrade"></iframe>
			</div>
		</div>
	</div>
</div>